import { render } from "./EditPropertyView.vue?vue&type=template&id=5acb4c08&scoped=true"
import script from "./EditPropertyView.vue?vue&type=script&lang=js"
export * from "./EditPropertyView.vue?vue&type=script&lang=js"

import "./EditPropertyView.vue?vue&type=style&index=0&id=5acb4c08&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acb4c08"]])

export default __exports__